export default Object.freeze({
  ReadOnly: 1,
  Write: 2,
});
